import CloseIcon from '@/common/assets/icons/borderCloseIcon.svg?react';
import CameraIcon from '@/common/assets/icons/documentCameraIcon.svg?react';
import FlashIcon from '@/common/assets/icons/flashIcon.svg?react';
import FlashIsOnIcon from '@/common/assets/icons/flashIconIsOn.svg?react';
import Button from '@/common/components/base/button/Button';
import CameraCustomMedia from '@/common/components/camera/components/CameraCustomMedia';
import CameraLoading from '@/common/components/camera/components/CameraLoading';
import useCamera from '@/common/components/camera/hooks/useCamera';
import useTakePhoto from '@/common/components/camera/hooks/useTakePhoto';
import { ImageType } from '@/common/components/imageGallery/components/Extensions/moreItemsExtension/moreItemsExtension.type';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { Box, Flex } from 'styled-system/jsx';

const UploadDocumentCameraPage = ({
  onDenyCamera,
  updateImage,
  closeCamera,
  photoRotate = false,
}: {
  onDenyCamera: () => void;
  updateImage: (imageData: ImageType) => void;
  closeCamera: () => void;
  photoRotate?: boolean;
}) => {
  const photoRef = useRef<HTMLCanvasElement | null>(null);
  const {
    videoRef,
    handleClickLight,
    torchIsOn,
    disableCamera,
    setDisableCamera,
    stopStream,
    cameraStatus,
  } = useCamera({
    audio: true,
    onDenyCamera: onDenyCamera,
    rotate: true,
    closeCamera: closeCamera,
  });

  const { takePhoto } = useTakePhoto({
    photoRef,
    videoRef,
    rotate: photoRotate,
    onDenyCamera: onDenyCamera,
    hasSlider: false,
  });

  const captureImage = () => {
    takePhoto({
      afterTakePhoto: (data) => {
        setDisableCamera(false);
        stopStream();
        updateImage(data);
      },
    });
  };

  return createPortal(
    <>
      {cameraStatus === 'loading' ? <CameraLoading /> : null}

      <Flex
        flexDirection="column"
        display={cameraStatus === 'loading' ? 'none' : 'flex'}
      >
        <Flex
          zIndex="camera"
          position="fixed"
          left="0"
          top="0"
          width={window.innerWidth}
          backgroundColor="black-1"
          height={'100lvh'}
        >
          <CameraCustomMedia photoRef={photoRef} videoRef={videoRef} />
        </Flex>
        <Box
          onClick={closeCamera}
          zIndex="camera-layout"
          position="fixed"
          left="20"
          top="30"
        >
          <CloseIcon />
        </Box>
        <Flex
          zIndex="camera-layout"
          backgroundColor="black-4"
          height="10%"
          width="100%"
          margin="auto"
          maxWidth="maxContainer"
          minH="100px"
          position="fixed"
          bottom="0"
          left="0"
          right="0"
          borderRadius="24px 24px 0 0"
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex
            flex={5}
            gap="5rem"
            alignItems="center"
            justifyContent="center"
            mr="6rem"
          >
            <Button
              backgroundColor="transparent"
              variant="text"
              p={0}
              onClick={() => (disableCamera ? undefined : captureImage())}
            >
              <CameraIcon fill={disableCamera ? '#c2c2c2' : '#fff'} />
            </Button>

            <Box onClick={() => handleClickLight()}>
              {torchIsOn ? <FlashIsOnIcon /> : <FlashIcon />}
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </>,
    document.body,
  );
};

export default UploadDocumentCameraPage;
